import { Button } from "@/shared/components/ui/button";
import { useTranslation } from "react-i18next";
import { Card } from "@/shared/components/ui/card";
import { Circle, MessageCircleQuestion, Timer } from "lucide-react";
import "./answering.scss";
import { useSelector } from "@/core/redux/store";
import { InboxType } from "@/shared/services/interface/responses/IInboxResponses";
import { TextAllFirstLetterToUpperCase } from "../helper/list-item-helper";
import { Avatar, AvatarImage } from "@/shared/components/ui/avatar";
import { Badge } from "@/shared/components/ui/badge";
import { useNavigate } from "react-router-dom";
import { getDashboardLink } from "@/shared/utils/link";
import { ROUTES } from "@/core/router/routes";

export default function AnsweringSpecificationInbox() {
  const navigation = useNavigate();
  const selectedInbox = useSelector((state) => state.inbox.selectedInbox);
  const me = useSelector((state) => state.user.me);
  const { t } = useTranslation();

  if (!selectedInbox) return;

  const GetCardConfig = () => {
    switch (selectedInbox.type) {
      case InboxType.SUPPLIER_SPECIFICATION_INVITE:
        return {
          color: "#F9CF6C",
          border: "1px solid #F9CF6C",
          boxShadow: "0px 0px 0px 6px rgba(249, 207, 108, 0.15)",
        };
      case InboxType.SUPPLIER_SPECIFICATION_INVITE_STARTED:
        return {
          color: "#3B82F6",
          border: "1px solid #3B82F6",
          boxShadow: "0px 0px 0px 6px rgba(59, 130, 246, 0.15)",
        };
      case InboxType.SUPPLIER_SPECIFICATION_INVITE_COMPLETED:
        return {
          color: "#4EDB68",
          border: "1px solid #4EDB68",
          boxShadow: "0px 0px 0px 6px rgba(123, 216, 132, 0.15)",
        };
      default:
        return {
          color: "#F9CF6C",
          border: "1px solid #9C9CA4",
          boxShadow: "0px 0px 0px 6px rgba(113, 113, 122, 0.15)",
        };
    }
  };
  const { color, border, boxShadow } = GetCardConfig();

  const GetBadgeText = () => {
    switch (selectedInbox.type) {
      case InboxType.SUPPLIER_SPECIFICATION_INVITE:
        return t("waiting-description");
      case InboxType.SUPPLIER_SPECIFICATION_INVITE_STARTED:
        return t("started");
      case InboxType.SUPPLIER_SPECIFICATION_INVITE_COMPLETED:
        return t("completed");
      default:
        return t("time-out");
    }
  };

  const showAllAnswers = () => {
    // return;
    if (
      selectedInbox.type === InboxType.SUPPLIER_SPECIFICATION_INVITE_COMPLETED
    ) {
      navigation(
        getDashboardLink(ROUTES.Dashboard.Specification.ProductAnswers) +
          `?specificationId=${selectedInbox?.metadata?.specification?.id}&companyId=${selectedInbox?.metadata?.specification?.companyId}&hash=${selectedInbox?.metadata?.specification?.hash}`
      );
    }
    return false;
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4 mb-5">
          <Avatar className="w-[40px] h-[40px]">
            <AvatarImage src={"https://github.com/shadcn.png"} />
          </Avatar>
          <div className="flex flex-col">
            <span className="text-[14px] font-700 text-muted-foreground ">
              {me?.id === selectedInbox.metadata?.receivedBy?.id
                ? selectedInbox.metadata?.receivedBy?.name
                : selectedInbox.metadata?.sendedBy?.name ?? t("procright-user")}
            </span>
            <span className="text-[12px] font-500 text-muted-foreground ">
              {selectedInbox.metadata?.sendedBy?.email}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Badge
            variant="outline"
            className="flex items-center gap-1 justify-center"
          >
            <Circle
              size={8}
              className={`text-[${color}]`}
              color={color}
              fill={color}
            />
            <span className="text-[13px] font-500 text-muted-foreground mt-0.5">
              {GetBadgeText()}
            </span>
          </Badge>
        </div>
      </div>
      <Card className="w-full py-[30px]" style={{ border, boxShadow }}>
        <div className="share-content flex flex-col items-center justify-center  rounded-lg">
          <div className="share-content-header flex flex-col items-center justify-center">
            <Card className="w-[40px] h-[40px] flex items-center justify-center shadow-md">
              <img
                src={
                  "https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png"
                }
                alt="logo"
                className="!w-[30px] !h-[30px] object-contain"
              />
            </Card>

            <p className="text-[24px] font-600 text-black mt-3">
              {TextAllFirstLetterToUpperCase(
                selectedInbox.metadata?.product.name || ""
              )}
            </p>
            <div
              className="w-[450px] h-[1px] mt-2 mb-3"
              style={{
                background:
                  "linear-gradient(90deg, #FFF 0%, rgba(102, 102, 102, 0.40) 46.5%, #FFF 98.5%)",
              }}
            ></div>
            <h1 className="share-title text-[16px] font-600 text-center">
              {selectedInbox.metadata?.specification?.name}
            </h1>
          </div>

          <p className="share-description-text text-[12px] font-500 text-muted-foreground mt-[10px] text-center px-10">
            {t("your-feedback-is-critical-description")}
          </p>

          <p className="footer-title text-[12px] font-700 text-black mt-[30px] mb-[16px]">
            {t("how-long-will-it-take")}
          </p>
          <div className="footer-buttons flex items-center justify-center gap-2">
            <Button variant="outline" className="footer-button">
              <MessageCircleQuestion size={20} />
              <span className="mt-[3px]">
                {t("have-count-items", {
                  count: 100,
                })}
              </span>
            </Button>
            <Button variant="outline" className="footer-button">
              <Timer size={20} />
              <span className="mt-[3px]">
                {t("minute-count", {
                  minute: String(Math.floor((100 * 30) / 60)),
                })}
              </span>
            </Button>
          </div>
        </div>
      </Card>
      {selectedInbox.type ===
        InboxType.SUPPLIER_SPECIFICATION_INVITE_COMPLETED && (
        <div className="flex gap-2 mt-4">
          <Button variant="default" className="w-full" onClick={showAllAnswers}>
            {t("inbox:show-all-answers")}
          </Button>
        </div>
      )}
    </div>
  );
}
